import type { FC } from "react";
import { memo, useState } from "react";
import type { AuthIconProps } from "./auth-icon.types";
import { AuthWrapper, StyledAuthIcon } from "./auth-icon.styles";
import { Menu } from "./menu";
import { Popover } from "@mui/material";

export const AuthIcon: FC<AuthIconProps> = memo(({ name }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AuthWrapper>
      <StyledAuthIcon onClick={handleClick}>
        {name?.substring(0, 1)}
      </StyledAuthIcon>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        sx={{ marginTop: "8px" }}
      >
        <Menu handleClose={handleClose} />
      </Popover>
    </AuthWrapper>
  );
});
